import { ALAIN_I18N_TOKEN, MenuService, SettingsService } from '@delon/theme';
import { Component, Inject, OnDestroy, Optional } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NzMessageService, NzModalService } from 'ng-zorro-antd';
import { DA_SERVICE_TOKEN, SocialOpenType, SocialService, TokenService } from '@delon/auth';
import { ReuseTabService } from '@delon/abc';
import { environment } from '@env/environment';
import { JyUserService } from '../../jy-authorization/user/jy-user.service';
import { CommonsService } from '@core/service/commons.service';

import { StartupService } from '@core/startup/startup.service';
import { JySystemConfigService } from '../../jy-commons/system-config/jy-system-config.service';
import { I18NService } from '@core/i18n/i18n.service';
import { PasswordService } from '../../../layout/passport/password.service';
import { el } from '@angular/platform-browser/testing/src/browser_util';

@Component({
  selector: 'passport-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.less'],
  providers: [SocialService],
})
export class UserLoginComponent implements OnDestroy {
  scan:any = false;
  wechatMsg:any  ={};
  i8 = 'zh-CN';
  form: FormGroup;
  pswForm: FormGroup;
  error = '';
  type = 0;
  loading = false;
  spin = false;
  errorMsg = true;
  errorMsgPhone = true;
  firstLogin = false;
  //服务号微信id
  fwWechatId:string;
  //企业微信id
  qyWechatId:string;
  //密码强度校验器开关
  visible = false;
  //密码强度
  status: string = 'pool';
  progress = 0;
  passwordProgressMap = {
    ok: 'success',
    pass: 'normal',
    pool: 'exception',
  };
  //用户
  user: any = {};


  //密码长度
  passwordLength: number;
  langs: any[];

  constructor(
    fb: FormBuilder,
    private router: Router,
    public msg: NzMessageService,
    private modalSrv: NzModalService,
    private settingsService: SettingsService,
    private socialService: SocialService,
    private jyUserService: JyUserService,
    private commons:CommonsService,
    private message: NzMessageService,
    private jySystemConfig: JySystemConfigService,
    private passwordService:PasswordService,
    @Optional()
    @Inject(ReuseTabService)
    private reuseTabService: ReuseTabService,
    @Inject(DA_SERVICE_TOKEN) private tokenService: TokenService,
    public settings: SettingsService,
    @Inject(ALAIN_I18N_TOKEN) private i18n: I18NService,
    private startupService:StartupService,
    private menuService:MenuService
  ) {
    // 清空路由复用信息
    this.reuseTabService.clear();

    this.langs = this.i18n.getLangs();
    let currentLang = this.i18n.currentLang;
    this.change(currentLang);
    this.form = fb.group({
      userName: [null, [Validators.required, Validators.minLength(5)]],
      password: [null, Validators.required],
      mobile: [null, [Validators.required, Validators.pattern(/^1\d{10}$/)]],
      captcha: [null, [Validators.required]],
      remember: [true],
    });
    this.pswForm = fb.group({
      newPassword: [
        null,
        [
          Validators.required,
          Validators.minLength(this.passwordLength),
          this.checkPassword.bind(this),
        ],
      ],
      rePassword: [null, [Validators.required, this.confirmPsw]],
    });
    let href = window.location.href;
    let fwIndex = href.lastIndexOf("fwOpenId=");
    if (fwIndex > 0){
      let suf = href.substring(fwIndex+9,href.length);
      this.fwWechatId = suf;
      this.commons.showInfoMessage("passport.login.countToWeChat");
    }

    let qyIndex = href.lastIndexOf("qyOpenId=");
    if (qyIndex > 0){
      let suf = href.substring(qyIndex+9,href.length);
      this.qyWechatId = suf;
      this.commons.showInfoMessage("passport.login.toWeChat");
    }

    let loginIndex = href.lastIndexOf("Authorization=");
    if (loginIndex > 0){
      let suf = href.substring(loginIndex+14,href.length);
      this.goHomePage(suf,this.commons.translate('passport.login.weChatUser'))
    }
    modalSrv.closeAll();
  }

  scanLogin(){
    this.passwordService.getAll().subscribe(data=>{
      this.wechatMsg = data;
    });
    this.scan = true;
  }

  passwordLogin(){
    this.scan = false;
  }

  change(lang) {
    this.i18n.use(lang);
    this.settings.setLayout('lang', lang);
  }

  //验证密码强度的方法
  checkPassword(control: FormControl) {
    if (!control) return null;
    const self: any = this;
    self.visible = !!control.value;
    if (control.value && control.value.length > 9) self.status = 'ok';
    else if (control.value && control.value.length > 5) self.status = 'pass';
    else self.status = 'pool';

    if (self.visible)
      self.progress =
        control.value.length * 10 > 100 ? 100 : control.value.length * 10;
  }

  //验证两次输入的密码是否相同
  updateConfirmValidator(): void {
    Promise.resolve().then(() => this.pswForm.controls.rePassword.updateValueAndValidity());
  }

  confirmPsw = (control: FormControl): { [s: string]: boolean } => {
    if (!control.value) {
      return { required: true };
    } else if (control.value !== this.pswForm.controls.newPassword.value) {
      return { confirm: true, error: true };
    }
  };

  //失去焦点隐藏新密码强度校验
  hiddenVisible() {
    this.visible = false;
  }

  // region: fields

  get userName() {
    return this.form.controls.userName;
  }

  get password() {
    return this.form.controls.password;
  }

  get mobile() {
    return this.form.controls.mobile;
  }

  get captcha() {
    return this.form.controls.captcha;
  }

  get remember() {
    return this.form.controls.remember;
  }

  // endregion

  switch(ret: any) {
    this.type = ret.index;
  }

  // region: get captcha

  count = 0;
  interval$: any;
  getCaptcha() {
    if(this.form.controls['mobile'].value){
      this.count = 59;
      this.interval$ = setInterval(() => {
        this.count -= 1;
        if (this.count <= 0) clearInterval(this.interval$);
      }, 1000);
      this.passwordService.getCode(this.form.controls['mobile'].value).subscribe((data)=>{

      },(data)=>{
        if(data.messageType=='E') {
          if (this.count >= 0){
            clearInterval(this.interval$);
            this.count = 0;
          }
        }
      })
    }else{
      this.commons.showInfoMessage('请输入手机号获取验证码')
    }

  }


  submit() {
    if(this.type){
      //手机验证码  登录
      this.error = '';
      this.mobile.markAsDirty();
      this.mobile.updateValueAndValidity();
      this.captcha.markAsDirty();
      this.captcha.updateValueAndValidity();
      if (this.mobile.invalid || this.captcha.invalid) {
        return;
      }
      let phoneCodeData = {
        username: this.mobile.value,
        password: this.captcha.value,
        rememberMe: this.remember.value,
        loginType:"MOBILE_SMS_CODE",
      };
      this.jyUserService.newLogin(phoneCodeData).subscribe((result) => {
        this.login(result,phoneCodeData['loginType'])

      },() => {
        this.spin = false;
        this.loading = false;
      });
      this.loading = false;

    }else{
      //账号登录
      this.error = '';
      this.userName.markAsDirty();
      this.userName.updateValueAndValidity();
      this.password.markAsDirty();
      this.password.updateValueAndValidity();
      if (this.userName.invalid || this.password.invalid) {
        return;
      }
      // **注：** DEMO中使用 `setTimeout` 来模拟 http
      // 默认配置中对所有HTTP请求都会强制[校验](https://ng-alain.com/auth/getting-started) 用户 Token
      // 然一般来说登录请求不需要校验，因此可以在请求URL加上：`/login?_allow_anonymous=true` 表示不触发用户 Token 校验
      this.loading = true;
      this.spin = true;
      var loginData = {
        username: this.userName.value,
        password: this.password.value,
        rememberMe: this.remember.value,
        fwOpenid:this.fwWechatId,
        qyOpenid:this.qyWechatId
      };
      this.jyUserService.newLogin(loginData).subscribe((result) => {
        this.login(result,this.errorMsg)

      },() => {
        this.spin = false;
        this.loading = false;
      });
      this.loading = false;
    }

  }
  //登录函数
  login(result,flag){
    //用户名错误
    if (result != null && ['errorUsername', 'passwordExpired', 'notActivated', 'invalid', 'firstUpdatePassword', 'error'].includes(result.status)) {
      if (['passwordExpired', 'firstUpdatePassword'].includes(result.status)) { // 首次登录需要修改密码
        if(result.errorMessage){
          this.commons.showErrorMessage(result.errorMessage);
        }

        //如果不输则用默认密码登录
        if(this.form.controls.password.value){
          this.user['password'] = this.form.controls.password.value;
        }else{
          this.user['password'] = "123456";
        }

        this.getPasswordLength();
        this.firstLogin = true;
      }
      if (['notActivated', 'error', 'invalid', 'errorUsername'].includes(result.status)) {
        if (result.status == 'errorUsername') {
          flag == 'MOBILE_SMS_CODE' ? this.errorMsg = false : this.errorMsg = false;
        }
        if (result.errorMessage == 'already lock and unlock at') {
          let msg = result.errorMessage;
          msg = msg + result.userDto.unLockTime;
          this.commons.showErrorMessage(msg);
        } else {
          this.commons.showErrorMessage(result.errorMessage || result.msg);
        }
      }
      this.loading = false;
      this.spin = false;
      return;
    }
    this.goHomePage(result.token,this.userName.value)
  }


  //是否进行跳转
  toRegister(){
    this.passwordService.supplierState().subscribe(data=>{
      this.spin = false;
      if(data.supplierDto && data.supplierDto.statusName=='注册'){
        this.router.navigate(['/supplier-guide/supplier']);
      }else{
        this.router.navigate(['/supplier-guide/purchase-business']);
      }
    },() => this.spin=false)

  }





  goHomePage(token,name){
    //菜单初始化
    this.menuService.add([]);
    // 清空路由复用信息
    this.reuseTabService.clear();
    // 设置Token信息
    this.tokenService.set({
      token: token,
      name: name,
      time: +new Date(),
    });
    localStorage.removeItem('lockBol');//清楚锁屏状态
    // 跳转

    this.passwordService.userInfo().subscribe(data => {
      if(data.userType==0){
        this.toRegister()
      }else{
        this.spin = false;
        this.router.navigate(['/supplier-guide/purchase-business']);
      }
    },() => this.spin = false)

  }

  // region: social

  getPasswordLength(){
    this.jySystemConfig.getPasswordLength().subscribe(data => {
      this.passwordLength = data
    },error1 => {
      this.passwordLength = 6
    })
  }

  open(type: string, openType: SocialOpenType = 'href') {
    let url = ``;
    let callback = ``;
    if (environment.production)
      callback = 'https://cipchk.github.io/ng-alain/callback/' + type;
    else callback = 'http://localhost:4200/callback/' + type;
    switch (type) {
      case 'auth0':
        url = `//cipchk.auth0.com/login?client=8gcNydIDzGBYxzqV0Vm1CX_RXH-wsWo5&redirect_uri=${decodeURIComponent(
          callback,
        )}`;
        break;
      case 'github':
        url = `//github.com/login/oauth/authorize?client_id=9d6baae4b04a23fcafa2&response_type=code&redirect_uri=${decodeURIComponent(
          callback,
        )}`;
        break;
      case 'weibo':
        url = `https://api.weibo.com/oauth2/authorize?client_id=1239507802&response_type=code&redirect_uri=${decodeURIComponent(
          callback,
        )}`;
        break;
    }
    if (openType === 'window') {
      this.socialService
        .login(url, '/', {
          type: 'window',
        })
        .subscribe(res => {
          if (res) {
            this.settingsService.setUser(res);
            this.router.navigateByUrl('/');
          }
        });
    } else {
      this.socialService.login(url, '/', {
        type: 'href',
      });
    }
  }

  pswSubmit(){
    for (const i in this.pswForm.controls) {
      this.pswForm.controls[i].markAsDirty();
      this.pswForm.controls[i].updateValueAndValidity();
    }
    if (this.pswForm.status == 'INVALID') {
      return;
    }
    this.user['action'] = "firstLogin";
    if(this.type){
      this.user['login'] = this.mobile.value;
    }else{
      this.user['login'] = this.userName.value;
    }
    this.jyUserService.updatePsw(this.user).subscribe(data => {
      if (data.status == 201) {
        this.commons.showErrorMessage('jy-authorization.user-info.tips.201');
      } else if (data.status == 202) {
        this.commons.showErrorMessage('jy-authorization.user-info.tips.202');
      } else if (data.status == 203) {
        this.commons.showErrorMessage('jy-authorization.user-info.tips.203');
      } else {
        this.commons.showSuccessMessage('passport.login.pswUpdate.successTip');
        this.password.reset();
        this.pswCancel()
      }
    })
  }

  pswCancel(){
    this.pswForm.reset();
    this.firstLogin = false;
  }

  cancelError(){
    this.errorMsg = true;
    this.errorMsgPhone=true;
  }

  // endregion

  ngOnDestroy(): void {
    if (this.interval$) clearInterval(this.interval$);
  }
}
